export default __webpack_public_path__ + "static/curve-7804194dbd685f71004a6eefb8c3314d.png";